import React from 'react';
import { useConnectivity } from '../contexts/ConnectivityContext';

export default function ConnectivityBanner() {
  const { apiOnline, isChecking, checkHealth } = useConnectivity();
  if (apiOnline) return null;
  return (
    <div className="fixed bottom-0 left-0 right-0 p-2 text-xs sm:text-sm bg-yellow-200 text-navy-900 border-t border-yellow-400 flex items-center justify-center gap-3 z-50">
      Servidor indisponível. Algumas ações estão desativadas.
      <button
        className="underline"
        disabled={isChecking}
        onClick={() => checkHealth()}
      >
        {isChecking ? 'Verificando...' : 'Tentar novamente'}
      </button>
    </div>
  );
}


